import { GenericApi } from "./generic.api";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICollection } from "../model/collection.model";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";
import { Observable } from "rxjs";
import { createUrl } from "./api.util";

// Convenience Type
type T = ICollection;

@Injectable()
export class CollectionApi extends GenericApi<T> {
  public path = "collections";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  collectionList = (params: HttpParams): Observable<QueryResult<ICollection>> => {
    return this.httpClient.get<QueryResult<ICollection>>(createUrl(this.path), {
      params,
    });
  };

  readonly restore = (id: number | string): Observable<{ success: boolean }> =>
    this.httpClient.get<{ success: boolean }>(
      createUrl(this.path, id, "restore"),
      {},
    );

  readonly createCollectionProduct = (data: {
    collectionId: string;
    productId: number;
  }): Observable<{ success: boolean }> =>
    this.httpClient.post<{ success: boolean }>(
      createUrl(this.path, "collection-product"),
      data,
    );

  readonly deleteCollectionProduct = (
    id: number,
  ): Observable<{ success: boolean }> =>
    this.httpClient.delete<{ success: boolean }>(
      createUrl(this.path, "collection-product", id),
    );
}
